mutation deleteInvitation($id: ID) {
  deleteInvitation(id: $id) {
    id
  }
}
